import ApiProtectedRequest from "utils/apiProtectedClient";
import { TargetSessionMetricsResponse, GoalMasteryHistoryChart } from "./types/charts";

const EP_BASE = "/api";

/**
 * GET /targets/{targetId}/session-metrics
 *
 * Returns the target's L4 derived time-series: the measurement `primitive_type`
 * plus one metric object per target session (oldest first). `primitive_type`
 * is null when the target has no L-Model config. 404 if the target is missing.
 */
export async function getTargetSessionMetrics(targetId: number) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();

  return await Request.get<TargetSessionMetricsResponse>(
    `${EP_BASE}/targets/${targetId}/session-metrics`
  );
}

/**
 * GET /goals/{goalId}/mastery-history
 *
 * Returns the goal's weekly cumulative count of targets that reached `met`.
 * Week 1 begins on the goal's `created_at`; series runs week 1 → current week.
 * 404 if the goal is missing.
 */
export async function getGoalMasteryHistory(goalId: number) {
  const apr = new ApiProtectedRequest();
  const Request = apr.getRequest();

  return await Request.get<GoalMasteryHistoryChart>(
    `${EP_BASE}/goals/${goalId}/mastery-history`
  );
}
